export default __webpack_public_path__ + "static/media/windows-error-ringtone.673b7ce3.mp3";